var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'menuSearch'}}},[_c('LogoSvg',{attrs:{"alt":"logo"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }